import {sortedProfilesByFirstName} from './helperFunctions';

const getNonClientProfiles = profiles =>
  sortedProfilesByFirstName(profiles).filter(profile => profile.permission && profile.permission.type !== 'professional');

export {getNonClientProfiles};
export default getNonClientProfiles;
